import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleNotes = {
    list: (filters) => axios.post(API_URL + "/vehicleNotes/list", filters).then(({ data }) => data.data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + "/vehicleNotes/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + "/vehicleNotes", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + "/vehicleNotes/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/vehicleNotes/" + id).catch((err) => { throw err }),

    getVehicleInfo: async (plate) => axios.get(API_URL + "/vehicleNotes/getVehicleInfo/" + plate).catch((err) => { throw err }),
};

export default VehicleNotes;